"use client";
import React, { useEffect, useState } from "react";
import { handleRecentBlog } from "@/utils/blogs";
import ArticleCard from "./ArticleCard";
import { StaticImageData } from "next/image";
import CommonTitle from "../common/CommonTitle";

export type TArticleType = {
  tag: string;
  title: string;
  image: StaticImageData | string | null;
  description: string;
  author: string;
  posted_at: string;
  linkUrl: string;
};

export type TBlogItem = {
  category_detail?: { title?: string };
  title?: string;
  f_image_url?: string;
  description?: string;
  creator?: string;
  published_date?: string;
  slug?: string;
};

const ArticlesArea = ({ category }: { category: string }) => {
  const [articles, setArticles] = useState<TArticleType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      try {
        const data: TBlogItem[] = await handleRecentBlog(category);
        const formattedArticles = data.map((item) => ({
          tag: item.category_detail?.title || "Uncategorized",
          title: item.title || "Untitled",
          image: item.f_image_url || null,
          description: item.description || "",
          author: item.creator || "Unknown Author",
          posted_at: new Date(item.published_date || "").toLocaleDateString(
            "en-US",
            {
              month: "short",
              year: "numeric",
            },
          ),
          linkUrl: `/blog/${item.slug}`,
        }));
        setArticles(formattedArticles);
      } catch (error) {
        console.error("Failed to fetch articles:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [category]);

  const placeholderCount = 2;

  return (
    <section className="py-[20px] xl:py-[40px]">
      <div className="container">
        <CommonTitle
          color="#202020"
          fontWeightClass="font-semibold"
          fontSizeClass="text-[24px] lg:text-[32px]"
        >
          Related articles
        </CommonTitle>
        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-5 xl:gap-[30px]">
          {loading ? (
            Array.from({ length: placeholderCount }).map((_, index) => (
              <ArticleCard key={index} loading />
            ))
          ) : articles.length > 0 ? (
            articles.map((item, index) => (
              <ArticleCard key={index} article={item} />
            ))
          ) : (
            <div className="col-span-full text-center">
              <h2 className="text-[24px] font-normal leading-[32px] text-[#9B9B9B] lg:text-[32px]">
                No related articles found.
              </h2>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ArticlesArea;
